import { enumConvert } from '../../helpers/enumConvert';
import { RiskToleranceBase } from '../Base/RiskTolerance';

export const TKARiskTolerance = enumConvert(RiskToleranceBase);
